// const host = "http://localhost:8081";
const host = window.config.baseUrl; //"http://localhost:9090/elevatorms";
// const host = "http://172.16.153.103:9090/elevatorms";
// const host = "http://10.96.143.27:13001/elevatorms";
// const host = "https://elevator.bivale.cn:10502/elevatorms";
// const host = "";
export default {
  // ws_url: "ws://10.98.2.204:14301",
  // ws_url: "ws://10.98.203.94:14301",
  // ws_url: "ws://218.107.46.70:14301"
  root_host: host,
  ws_url: window.config.wsUrl,
  get_captcha_url: host + "/user/captcha",
  get_sms_code_url: host + "/user/smsCode",
  user_login_url: host + "/login",
  user_logout_url: host + "/user/logout",
  user_password_modify_url: host + "/user/modifyPassword",
  user_phone_modify_url: host + "/user/modifyPhone",
  user_login_password_modify_url: host + "/user/modifyLoginPassword",
  user_register_phone_url: host + "/user/registerPhone",
  search_device_patrol_url: host + "/elevator/patrol/list",
  group_search_device_patrol_url: host + "/elevator/patrol/groupList",
  search_device_patrol_job_num_url: host + "/elevator/patrol/jobNumList",
  search_device_patrol_monitor_job_num_url:
    host + "/elevator/patrol/monitorJobNumList",
  save_device_patrol_fault_url: host + "/elevator/patrol/saveFaultReport",
  get_device_patrol_fault_url: host + "/elevator/patrol/getFaultReport/",
  update_device_patrol_status_url: host + "/elevator/patrol/updateDeviceStatus",
  statistics_device_status_count_url: host + "/statistics/deviceStatusCount",
  statistics_elevator_status_count_url:
    host + "/statistics/elevatorStatusCount",
  statistics_elevator_alarm_status_count_url:
    host + "/statistics/elevatorAlarmStatusCount",
  statistics_days_stop_fault_count_url: host + "/statistics/daysStopFaultCount",
  statistics_main_plan_status_count_url:
    host + "/statistics/mainPlanStatusCount",
  statistics_yesterdy_stop_fault_count_url:
    host + "/statistics/yesterdayStopFaultCount",
  export_yesterdy_stop_fault_url: host + "/statistics/exportYesterdayStopFault",
  statistics_elevator_age_count_url:
    host + "/statistics/statisticsElevatorAgeList",
  statistics_fault_map_url: host + "/statistics/statisticsFaultListForMap",
  search_year_cheak_list_url: host + "/statistics/yearCheckList",
  search_contract_expire_list_url: host + "/statistics/contractExpireList",
  search_agreement_url: host + "/agreement/list",
  export_agreement_url: host + "/agreement/export",
  statistics_trap_url: host + "/faultTask/statisticsTrap",
  search_real_elevator_fault_url: host + "/faultTask/getRealElevatorFault",

  search_fault_report_url: host + "/faultReport/list",
  update_fault_report_status_url: host + "/faultReport/updateStatus",
  delete_fault_report_url: host + "/faultReport/delete",

  group_search_alarm_url: host + "/elevator/alarm/groupList",
  search_alarm_url: host + "/elevator/alarm/list",
  get_alarm_status_count_url: host + "/elevator/alarm/statusCount",
  search_jobNum_alarm_url: host + "/elevator/alarm/listByJobNum",
  export_alarm_url: host + "/elevator/alarm/export",
  get_new_alarm_list_url: host + "/elevator/alarm/getNewAlarmList",
  save_return_call_url: host + "/elevator/alarm/saveReturnCall",
  get_return_call_url: host + "/elevator/alarm/getReturnCall",
  get_trapped_image_url: host + "/elevator/alarm/getTrappedImage",
  search_elevator_stop_sms_url: host + "/elevator/stopSms/list",
  get_domain_type_url: host + "/elevator/getDomainTypeList",
  get_status_desc_url: host + "/elevator/getStatusDescList",

  search_elevator_video_url: host + "/elevatorVideo/list",
  save_elevator_video_url: host + "/elevatorVideo/save",
  get_elevator_video_url: host + "/elevatorVideo/get/",
  delete_elevator_video_url: host + "/elevatorVideo/delete",
  get_elevator_video_path_url: host + "/elevatorVideo/getVideoUrl",
  get_iot_video_url: host + "/elevatorVideo/getIotVideoUrl",
  get_monitor_video_path_url: host + "/elevatorVideo/getMonitorVideoUrl",
  import_video_device_url: host + "/elevatorVideo/importVideoDevice",
  search_sub_account_device_url: host + "/elevatorVideo/getSubDeviceInfo",
  add_sub_account_device_url: host + "/elevatorVideo/addSubDevice",
  add_device_url: host + "/elevatorVideo/addDevice",
  set_video_encrypt_url: host + "/elevatorVideo/setVideoEncrypt",
  get_single_device_info_url: host + "/elevatorVideo/getSingleDeviceInfo",

  search_elevator_video_log_url: host + "/elevatorVideoLog/list",
  export_elevator_video_log_url: host + "/elevatorVideoLog/export",
  search_risk_confirm_log_url: host + "/riskConfirmLog/list",
  save_risk_confirm_log_url: host + "/riskConfirmLog/save",
  is_risk_confirm_url: host + "/riskConfirmLog/isRiskConfirm",

  search_lcd_equipment_url: host + "/lcdEquipment/list",
  search_lcd_equipment_issue_url: host + "/lcdEquipment/issueList",
  search_lcd_equipment_issue_url: host + "/lcdEquipment/issueList",
  lcd_equipment_issue_url: host + "/lcdEquipment/issue",
  lcd_equipment_audit_url: host + "/lcdEquipment/audit",

  search_malfunctions_url: host + "/malfunctions/list",
  search_diagnosis_url: host + "/diagnosis/list",

  search_main_plan_url: host + "/mainPlan/list",
  search_main_plan_job_num_url: host + "/mainPlan/jobNumList",
  get_main_evaluate_url: host + "/mainPlan/getEvaluate/",
  save_main_evaluate_url: host + "/mainPlan/saveEvaluate",
  get_main_image_list_url: host + "/mainPlan/getMainImageList",
  get_main_image_url: host + "/mainPlan/getMainImage",
  get_main_pdf_url: host + "/mainPlan/getMainPDF",
  export_main_plan_url: host + "/mainPlan/export",
  update_main_plan_status_url: host + "/mainPlan/updateStatus",

  search_main_supervise_url: host + "/supervise/list",
  get_personnel_position_url: host + "/supervise/getPersonnelPosition",
  get_personnel_track_url: host + "/supervise/getPersonnelTrack",
  get_gps84_to_bd09_url: host + "/supervise/GPS84ToBD09",

  search_elevator_stop_url: host + "/elevator/stop/list",
  search_elevator_stop_list_url: host + "/elevator/alarm/stopList",

  get_display_pages_url: host + "/display/pages",
  save_display_url: host + "/display/save",
  get_display_json_url: host + "/display/json",

  search_alarm_report_url: host + "/report/getAlarmReportList",
  export_alarm_report_url: host + "/report/exportAlarmReport",
  search_main_plan_report_url: host + "/report/getMainPlanReportList",
  export_main_plan_report_url: host + "/report/exportMainPlanReport",
  search_run_status_report_url: host + "/report/getRunStatusReportList",
  export_run_status_report_url: host + "/report/exportRunStatusReport",
  export_accessories_replace_report_url:
    host + "/report/exportAccessoriesReplaceReport",
  export_elevator_medical_report_url:
    host + "/report/exportElevatorMedicalReportPDF",
  export_contract_medical_report_url:
    host + "/report/exportContractMedicalReportPDF",

  search_elevator_url: host + "/elevator/list",
  save_elevator_url: host + "/elevator/save",
  save_elevator_energy_url: host + "/elevator/saveEnergy",
  search_monitor_elevator_map_url: host + "/elevator/getMonitorElevatorMap",
  get_qrcode_url: host + "/elevator/generateQRCode",
  escalator_settings_url: host + "/elevator/escalatorSettings",
  get_elevator_function_url: host + "/elevator/elevatorFunction",
  get_component_health_url: host + "/elevator/componentHealth",
  timing_url: host + "/elevator/timing",
  get_escalator_settings_url: host + "/elevator/escalatorSettings",
  get_elevator_by_jobnum_url: host + "/elevator/elevatorListByJobNum",

  save_property_url: host + "/property/save",
  get_property_url: host + "/property/get",

  search_owner_url: host + "/owner/list",
  save_owner_url: host + "/owner/save",
  get_owner_url: host + "/owner/get/",
  delete_owner_url: host + "/owner/delete",
  set_owner_received_sms_url: host + "/owner/setReceivedSms",
  get_owner_elevators_url: host + "/owner/getElevatorList",

  search_account_url: host + "/user/list",
  save_account_url: host + "/user/save",
  get_account_url: host + "/user/get/",
  delete_account_url: host + "/user/delete",
  get_account_roles_url: host + "/user/roles",
  get_account_permission_url: host + "/user/permissions",
  get_account_data_permission_url: host + "/user/dataPermissions",
  set_account_permission_url: host + "/user/set/permission",
  import_user_url: host + "/user/importUser",
  import_elevator_permission_url: host + "/user/importElevatorPermission",
  delete_elevator_permission_url: host + "/user/deleteElevatorPermission",
  export_elevator_permission_url: host + "/user/exportElevatorPermission",
  import_elevator_url: host + "/elevator/importElevator",
  export_elevator_url: host + "/elevator/export",
  export_elevator_year_check_url: host + "/elevator/exportYearCheck",
  export_elevator_run_count_url: host + "/elevator/exportRunCount",
  get_bind_monitor_elevator_url: host + "/user/getBindMonitorJobNumList",
  set_bind_monitor_elevator_url: host + "/user/addBindMonitorElevatorList",
  export_account_url: host + "/user/export",
  refresh_account_elevator_count_url: host + "/user/statisticsElevatorCount",
  send_user_sms_url: host + "/user/batchSendUserSMS",
  add_sub_user_url: host + "/user/addSubUser",

  search_role_url: host + "/role/list",
  save_role_url: host + "/role/save",
  get_role_url: host + "/role/get/",
  delete_role_url: host + "/role/delete",
  get_role_permissionTree_url: host + "/role/permissionTrees",
  get_role_permission_url: host + "/role/permissionIds",
  set_role_permission_url: host + "/role/set/permission",
  set_role_field_permission_url: host + "/role/setRoleFieldPermission",
  get_role_field_permission_url: host + "/role/getRoleFieldPermission/",
  set_role_index_permission_url: host + "/role/setRoleIndexPermission",
  get_role_index_permission_url: host + "/role/getRoleIndexPermission/",
  set_role_dictionary_permission_url:
    host + "/role/setRoleDictionaryPermission",
  get_role_dictionary_permission_url:
    host + "/role/getRoleDictionaryPermission/",
  get_parent_role_field_permission_url:
    host + "/role/getParentRoleFieldPermission/",
  get_role_permissionName_url: host + "/role/permissions",

  search_feedback_url: host + "/feedback/list",
  save_feedback_url: host + "/feedback/save",
  delete_feedback_url: host + "/feedback/delete",

  search_log_url: host + "/log/list",
  save_log_url: host + "/log/save",
  delete_log_url: host + "/log/delete",
  export_log_url: host + "/log/export",
  get_user_by_access_token: host + "/account/userbytoken",

  search_sms_receiver_url: host + "/smsReceiver/list",
  save_sms_receiver_url: host + "/smsReceiver/save",
  get_sms_receiver_url: host + "/smsReceiver/get/",
  delete_sms_receiver_url: host + "/smsReceiver/delete",
  sms_receiver_import_elevator_permission_url:
    host + "/smsReceiver/importElevatorPermission",

  search_weixin_url: host + "/wx/list",
  set_wx_url: host + "/user/setwx",
  unbind_wx_url: host + "/wx/unbind",

  search_alarm_push_record_url: host + "/alarmPush/list",
  export_alarm_push_url: host + "/alarmPush/export",
  search_wx_push_record_url: host + "/wxPush/list",
  export_wx_push_url: host + "/wxPush/export",

  allow_all_day_monitor_url: host + "/monitor/allow",

  search_notice_url: host + "/notice/list",
  search_history_notice_url: host + "/notice/historyList",
  search_user_notice_url: host + "/notice/userNoticeList",
  add_user_notice_url: host + "/notice/addUserNotice",
  save_notice_url: host + "/notice/save",
  get_notice_url: host + "/notice/get/",
  delete_notice_url: host + "/notice/delete",
  delete_history_notice_url: host + "/notice/deleteHistory",

  search_third_party_user_url: host + "/thirdPartyUser/list",
  save_third_party_user_url: host + "/thirdPartyUser/save",
  get_third_party_user_url: host + "/thirdPartyUser/get/",
  delete_third_party_user_url: host + "/thirdPartyUser/delete",

  download_template_url: host + "/user/downloadTemplate",
  get_elevator_maintain_record_date_url:
    host + "/statistics/mainPlanCountByMonth",
  get_elevator_rescue_progress_url: host + "/statistics/todayRescueProgress",
  get_run_times_distribute_url: host + "/statistics/runTimesDistribute",
  get_monthly_run_frequency: host + "/statistics/monthlyRunFrequency",
  get_elevator_for_big_screen: host + "/elevator/getElevatorForBigScreen",
  get_last_next_main: host + "/mainPlan/getLastNextMain",
  get_last_fault_record: host + "/statistics/lastFaultRecord",
  get_component_life_prediction: host + "/statistics/componentLifePrediction",
  get_run_quality_index: host + "/statistics/runQualityIndex",
  get_risk_fault: host + "/statistics/lastRiskFault",

  get_inspection_report_list: host + "/elevatorInspectionReport/list",
  get_report_detail: host + "/elevatorInspectionReport/getReportDetail",
  save_elevator_inspection_report: host + "/elevatorInspectionReport/save",
  get_elevator_inspection_report:
    host + "/elevatorInspectionReport/statisticsElevator",
  get_elevator_domain_list: host + "/elevator/domainList",
  get_elevator_statistics_domain:
    host + "/elevatorInspectionReport/statisticsDomain",
  batch_save_elevator_inspection_report:
    host + "/elevatorInspectionReport/batchSave",
  get_elevator_inspection_report_code:
    host + "/elevatorInspectionReport/indexList",
  save_elevator_inspection_report_code:
    host + "/elevatorInspectionReport/saveIndex",
  get_elevator_inspection_white_list:
    host + "/elevatorInspectionReport/whiteList",
  save_elevator_inspection_white_list:
    host + "/elevatorInspectionReport/saveWhiteList",
  get_elevator_inspection_unnormal_list:
    host + "/elevatorInspectionReport/unnormalElevatorList",
  get_elevator_inspection_code_list:
    host + "/elevatorInspectionReport/codeList",
  get_escalator_info: host + "/elevator/escalatorInfo",
  get_energy: host + "/elevator/energy",
  get_elevator_elec: host + "/elevator/elec",
  get_intercom_url: host + "/elevator/intercom",

  get_bi_signature_url: host + "/external/bi/signature", //获取BI系统验证的签名

  no_login_signature_auth_url: host + "/external/signAuth", //免登录签名认证路径

  search_external_system_url: host + "/externalSystem/list",
  save_external_system_url: host + "/externalSystem/save",
  get_external_system_url: host + "/externalSystem/get/",
  get_external_system_key_url: host + "/externalSystem/getKey/",
  delete_external_system_url: host + "/externalSystem/delete",

  get_fd_service_package_list_url: host + "/fullDay/getServicePackageList",
  add_fd_service_package_business_url:
    host + "/fullDay/addServicePackageBusiness",
  get_fd_advert_list_url: host + "/fullDay/getAdvertList",
  get_fd_banner_list_url: host + "/fullDay/getBannerList",
  get_fd_fault_report_list_url: host + "/fullDay/getFaultReportList",
  add_fd_fault_report_url: host + "/fullDay/addFaultReport",
  get_fd_fault_report_list_url: host + "/fullDay/getFaultReportList",
  get_fd_problem_feedback_list_url: host + "/fullDay/getProblemFeedBackList",
  add_fd_problem_feedback_url: host + "/fullDay/addProblemFeedBack",
  upload_fd_problem_feedback_url: host + "/fullDay/uploadProblemFeedBackFile",
  get_fd_problem_feedback_reply_list_url:
    host + "/fullDay/getProblemFeedBackReplyList",
  get_fd_problem_feedback_detail_url:
    host + "/fullDay/getProblemFeedBackDetail",
  get_fd_proposal_accessories_list_url:
    host + "/fullDay/getProposalAccessoriesList",
  get_fd_annual_inspection_list_url: host + "/fullDay/getAnnualInspectionList",
  get_fd_annual_inspection_calendar_url: host + "/fullDay/getAnnualInspectionCalendar",
  get_fd_payable_list_url: host + "/fullDay/getPayableList",
  add_fd_payable_progress_url: host + "/fullDay/addPayableProgress",
  get_fd_payable_progress_history_url: host + "/fullDay/getPayableProgressHistoryList",
  modify_fd_payable_project_url: host + "/fullDay/modifyPayableProject",
  get_fd_statement_list_url: host + "/fullDay/getStatementList",
  fd_statement_confirm_url: host + "/fullDay/statementConfirm",
  fd_statement_question_url: host + "/fullDay/statementQuestion",
  get_fd_quotes_list_url: host + "/fullDay/getQuotesList",
  get_fd_quotes_detail_url: host + "/fullDay/getQuotesDetail",
  get_fd_quotes_pdf_url: host + "/fullDay/getQuotesPdf",
  fd_quotes_confirm_url: host + "/fullDay/quotesConfirm",
  fd_quotes_pdf_forward_url: host + "/fullDay/quotesPdfForward",
  fd_quotes_dispute_url: host + "/fullDay/quotesDispute",
  get_fd_province_city_list_url: host + "/fullDay/getProvinceCityList",
  get_fd_dict_list_url: host + "/fullDay/getDictList",
  get_fd_company_list_url: host + "/fullDay/getCompanyList",
  get_fd_download_url: host + "/fullDay/getDownloadUrl",
  fd_oss_upload_url: host + "/fullDay/ossUploadFile",
  get_fd_emes_download_url: host + "/fullDay/getEmesDownloadUrl",
};
